export const notificationTone = new Audio("/media/plucky.mp3");
